import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";

//Image was exported with text
// import introImg from "../../assets/images/terms_condition_introImg.svg";

//New Image without text
import introImg from "../../assets/images/terms_condition_newIntroImg.svg";

import classes from "./TermsAndCondition.module.css";

const TermsAndCondition = () => {
    return (
        <div>
            <Nav />
            <div className={classes.main_section}>
                {/* image section */}
                <div
                    className={classes.intro_img}
                    style={{ backgroundImage: `url(${introImg})` }}
                >
                    {/* changed structured to use background image */}
                    {/* <img src={introImg} alt="" /> */}
                    Terms and Conditions
                </div>
                <div className={classes.text_area}>
                    {/* intro section */}
                    <div className={classes.introduction}>
                        <p id="date_ref" className={classes.small_heading}>
                            Effective from the 18th of November, 2022
                        </p>
                        <p className={classes.instruction_caps}>
                            PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY
                            BEFORE USING OUR SERVICE
                        </p>
                    </div>
                    {/* Acknowledgement */}
                    <div className="acknowledge">
                        <p className={classes.heading}>Acknowledgment</p>
                        <div
                            className={`${classes.child} ${classes.child_no_indent}`}
                        >
                            <p>
                                This page states the terms of use (“Terms”)
                                under which you (“You”) may use the
                                Applyforme.com Website, and Your relationship
                                with Applyforme.com Ltd (“Applyforme.com”, “we”
                                or “us”).{" "}
                            </p>
                            <p>
                                Please read them carefully as they affect Your
                                rights and liabilities under the law. If You do
                                not agree to these Terms, please do not register
                                for or use the Applyforme.com Website. These
                                Terms are effective as of 18-Nov-2022. If You
                                have any questions on the Terms, please contact
                                us.
                            </p>
                            <p>These Terms shall describe the following:</p>
                            <ol className={classes.indent}>
                                <li>Use of Site</li>
                                <li>What’s in these terms?</li>
                                <li>
                                    There are other terms that may apply to you
                                </li>
                                <li>Payment Policies</li>
                                <li>Employment Business Regulations</li>
                                <li>
                                    Object of the agreement and scope of the
                                    services
                                </li>
                                <li>Your Account</li>
                                <li>Social Accounts</li>
                                <li>Dormant Emails</li>
                                <li>Term and Termination</li>
                            </ol>
                        </div>
                    </div>
                    {/* use of site */}
                    <div className="use-of-site">
                        <p className={classes.heading}>1. Use of Site</p>
                        <div className={classes.child}>
                            <p>
                                <span className={classes.colored_span}>
                                    1.1.
                                </span>{" "}
                                The information and services available on the
                                site are provided for the sole purpose of
                                individuals looking for employment opportunities
                                and career-related information. Only for these
                                uses are you permitted to use, print, and
                                download information from the website.
                            </p>
                            <p>
                                Any unauthorized processing of information on
                                the site or any other unauthorized copying,
                                displaying, transmitting, or distribution of
                                material from the site shall be deemed a
                                material breach of these terms and conditions,
                                and in the case of a Jobseeker, "You" shall
                                entitle us to immediately terminate the Services
                                without prior notice.
                            </p>
                            <p>
                                Additionally, we retain the right to stop
                                offering the Services to you if we have cause to
                                think that you have engaged in any unauthorized
                                processing.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    1.2.
                                </span>{" "}
                                All copyright, database rights and other
                                intellectual property rights in the site and the
                                material available on the site belongs to us or
                                its third party suppliers. Use of the site does
                                not give you any proprietary rights in such
                                materials.
                            </p>
                        </div>
                    </div>
                    {/* 2 */}
                    <div>
                        <p className={classes.heading}>
                            2. What’s in these terms?
                        </p>
                        <div className={classes.child}>
                            <p className={classes.no_indent}>
                                These jobseeker terms (the “Jobseeker Terms“)
                                set out the information applicable to jobseekers
                                (the “Jobseekers“) who wish to use the Site and
                                apply to the contractual agreement (hereinafter
                                referred to as the “Agreement”) between Us and
                                you on the other hand, who are interested in or
                                use any career service that is offered at on the
                                Site or other websites that incorporate these
                                Terms of Use and our mobile applications
                                (“apps”) (collectively referred to as “Service”
                                hereinafter). Such websites and the apps are
                                collectively referred to as “Platforms”
                                hereinafter. If you do not agree to these
                                Jobseeker Terms, you must not use the Site.
                            </p>
                        </div>
                    </div>
                    {/* 3 */}
                    <div>
                        <p className={classes.heading}>
                            3. There are other Terms that may apply to you
                        </p>
                        <div className={classes.child}>
                            <p className={classes.no_indent}>
                                This Acceptable Use Policy refers to the
                                following additional terms, which also apply to
                                your use of the Site:
                            </p>
                            <ul className={classes.indent}>
                                <li>
                                    Our Privacy policy, which sets out the terms
                                    on which We process any personal data We
                                    collect from you, or that you provide to Us.
                                    By using the Site, you consent to such
                                    processing and you warrant that all data
                                    provided by you is accurate;
                                </li>
                                <li>
                                    Our Cookie policy, which sets out
                                    information about the cookies on the Site;
                                    and
                                </li>
                                <li>
                                    If you are a recruiter, our Recruiter terms
                                    and conditions, which sets out information
                                    applicable to Recruiters.
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* 4 */}
                    <div>
                        <p className={classes.heading}>4. Payment Policies</p>
                        <div className={classes.child}>
                            <p>
                                <span className={classes.colored_span}>
                                    4.1.
                                </span>{" "}
                                All amounts owing to APPLYFORME must be paid
                                before service will be fulfilled.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    4.2.
                                </span>{" "}
                                You are obliged to pay for the services that
                                APPLYFORME agrees to provide you with regardless
                                of whether you utilize or fully utilize those
                                services. If you do not provide APPLYFORME with
                                the necessary materials or information for
                                APPLYFORME to deliver these services to you, you
                                are still liable to APPLYFORME for full payment.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    4.3.
                                </span>{" "}
                                Payments using Quickteller, EFT / Bank Transfer,
                                Paystack or Flutterwave platform depend on the
                                selected payment method.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    4.4.
                                </span>{" "}
                                If you do not pay for services rendered on time,
                                APPLYFORME may disable your account without
                                notice and refuse to supply further services to
                                you.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    4.5.
                                </span>{" "}
                                You agree that APPLYFORME may disclose this
                                information to a credit reporting agency or any
                                other interested person.
                            </p>
                        </div>
                    </div>
                    {/* 5 */}
                    <div>
                        <p className={classes.heading}>
                            5. Employment Business Regulations
                        </p>
                        <div
                            className={`${classes.child} ${classes.child_no_indent}`}
                        >
                            <p>
                                The Conduct of Employment Business Regulations
                                (the “Regulations'') seek to ensure that
                                jobseekers are only proposed by employment
                                agencies for roles for which they are properly
                                qualified and that recruiters are only offered
                                job seekers who have the appropriate levels of
                                experience, training, qualifications and
                                authorisation for the position to be filled.
                            </p>
                            <p>
                                Since we are only a venue that propose or
                                introduce jobseekers to recruiters or vice
                                versa, it is recommended that, if you are a
                                jobseeker, you undertake the steps set out in
                                the Regulations to ensure your suitability for
                                the role advertised.
                            </p>
                            <p>These could include:</p>
                            <p>
                                If you are a jobseeker; checking the identity of
                                the recruiter and the nature of its business,
                                the commencement date and duration of the
                                position, the position to be filled including
                                type of work, location, hours and risks to
                                health and safety, experience, training,
                                qualifications and authorisation which the
                                recruiter considers necessary or are required by
                                law or otherwise to undertake the position,
                                whether any expenses are payable by you as a
                                jobseeker or whether there are any requirements
                                imposed by law or otherwise for you to satisfy
                                before taking up a position.
                            </p>
                        </div>
                    </div>
                    {/* 6 */}
                    <div>
                        <p className={classes.heading}>
                            6. Object of the agreement and scope of the Services
                        </p>
                        <div
                            className={`${classes.child} ${classes.child_no_indent}`}
                        >
                            <p>
                                We offer a variety of career services via the
                                Platforms. We want to be your lifelong career
                                assistant. If your life perspective changes, or
                                you are developing or reaching for new goals, we
                                offer the right career support.
                            </p>
                            <p>
                                You can use certain Services without
                                registration. The registration of a “Jobs by
                                email” or an account will offer you additional
                                functionalities and Services.
                            </p>
                            <p>
                                To provide you with the specific Services under
                                registration, we will store the date of your
                                last activity at the Platforms (“Last Activity
                                Date”), which can include the date of your
                                registration, and last use of Services like
                                applying for a job.
                            </p>
                        </div>
                    </div>
                    {/* 7 */}
                    <div>
                        <p className={classes.heading}>7. Your Account</p>
                        <div className={classes.child}>
                            <p className={classes.no_indent}>
                                Certain Services will only be available as part
                                of an account on the Site.
                            </p>
                            <p className={classes.no_indent}>
                                If you enter into an agreement for an account,
                                you can use additional Services as described
                                hereinafter. You can register for an account as
                                described below.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    7.1.
                                </span>{" "}
                                Should you wish to create an account with us,
                                you must provide a valid email address and a
                                password which we will store to perform our
                                obligation under this Agreement (or use Google).
                                After we have received your registration
                                application to create an account, we will
                                confirm the receipt of such an application with
                                a message to the email address provided by you.
                                The Agreement for your account between you and
                                us will come into effect when we activate your
                                account. The Agreement for your account between
                                you and us will come into effect when we
                                activate your account.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    7.2.
                                </span>{" "}
                                The completion of the registration by you only
                                constitutes an offer to enter into a contract.
                                We reserve the right to accept or decline the
                                conclusion of the contract at its own
                                discretion. There is no right to claim a
                                conclusion of contract.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    7.3.
                                </span>{" "}
                                You must provide the requested information and
                                data completely and truthfully. You are
                                responsible to keep your contact data
                                (especially your email-address) up to date and
                                to ensure that you can be contacted under the
                                address provided and that the email-address is
                                not transferred to another person. Should any of
                                the provided data change, you must adjust and
                                correct the data immediately. In the event of
                                incomplete or false information provided by you,
                                we shall have the right to block your account
                                and the access to our Platform temporarily or
                                permanently and/or terminate in accordance.
                            </p>
                        </div>
                    </div>
                    {/* 8 */}
                    <div>
                        <p className={classes.heading}>8. Social Accounts</p>
                        <div className={classes.child}>
                            <p>
                                <span className={classes.colored_span}>
                                    8.1.
                                </span>{" "}
                                You may use your social media accounts to create
                                and/or sign into your account. Once you have
                                created an account using your social media
                                account, if you would like to remove access you
                                will need to login to the said social media
                                account you had used to remove access i.e., for
                                Google users you will need to log into your
                                Google account in order to remove access.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    8.2.
                                </span>{" "}
                                We can also create an account with the details
                                you had provided by using your Apple, Facebook
                                or Google account (“social Accounts”) to create
                                a local Applyforme account. In order to retrieve
                                this account, you will need to set a password by
                                following the ‘forgotten password’ process. Once
                                we have created a local Applyforme account, you
                                will no longer need to use your Social Accounts
                                for logging in. If you register using your
                                Social Accounts on the mobile App, you cannot
                                login the same way on the web unless you
                                register using the same username and password or
                                your Google details for us to match the accounts
                                for you.
                            </p>
                        </div>
                    </div>
                    {/* 9 */}
                    <div>
                        <p className={classes.heading}>9. Dormant Emails</p>
                        <div className={classes.child}>
                            <p className={classes.no_indent}>
                                If you have an account but you have been
                                inactive for a predetermined period, we may
                                email you to check whether you are still on the
                                lookout for a job. This will not occur if you
                                have unsubscribed to receive emails from us. As
                                part of your lifelong career assistant and
                                recruiting agency, we like to be kept up to date
                                with your status quo.
                            </p>
                        </div>
                    </div>
                    {/* 10 */}
                    <div>
                        <p className={classes.heading}>
                            10. Term and Termination
                        </p>
                        <div className={classes.child}>
                            <p>
                                <span className={classes.colored_span}>
                                    10.1.
                                </span>{" "}
                                The agreement with you regarding your user
                                account and the services provided under these
                                terms is for a fixed term unless you voluntarily
                                request us to delete your account. Either party
                                may terminate this Agreement with immediate
                                effect and without cause.
                            </p>
                            <p>
                                <span className={classes.colored_span}>
                                    10.2.
                                </span>{" "}
                                We might amend these Jobseeker Terms from time
                                to time. Every time you wish to use the Site,
                                please check these Jobseeker Terms to ensure you
                                understand the terms that apply at that time.
                            </p>
                            <p>
                                Please view the{" "}
                                <a
                                    className={classes.colored_href}
                                    href="#date_ref"
                                >
                                    “Effective from”
                                </a>{" "}
                                date at the top of these terms to see when it
                                was last revised.
                            </p>
                            <p>
                                To contact us, please fill out our Contact us
                                form{" "}
                                <a
                                    className={classes.colored_href}
                                    href="/contact"
                                >
                                    here
                                </a>
                            </p>
                        </div>
                    </div>
                    {/*  */}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TermsAndCondition;
